package com.trevorwiebe.timesheet.invoicing.domain.model

import com.trevorwiebe.timesheet.core.domain.formatCentsAsDollars
import kotlinx.datetime.LocalDate

/** The part of a payment applied to one invoice. Money is whole cents. */
data class PaymentAllocation(
    val invoiceId: String,
    val invoiceNumber: Int,
    val amount: Int,
)

/** A check (or other payment) from a customer, split across one or more of their invoices. */
data class Payment(
    val id: String,
    val customerId: String,
    val customerName: String,
    val date: LocalDate,
    val amount: Int,
    val allocations: List<PaymentAllocation>,
    val notes: String = "",
) {
    val amountFormatted: String get() = "$" + amount.formatCentsAsDollars()

    fun amountAppliedTo(invoiceId: String): Int =
        allocations.filter { it.invoiceId == invoiceId }.sumOf { it.amount }
}
